<template>
  <page>
    <div>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <div class="headline">Claim Type Attachment Listing</div>
          <v-spacer></v-spacer>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>
        <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination"
          item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch" group-by="clmType" show-group-by>
          <template slot="items" slot-scope="props">
            <td>{{ appDesc(props.item.appId) }}</td>
            <td>{{ props.item.clmType }}</td>
            <td>{{ props.item.clmSubType }}</td>
            <td>{{ props.item.attachRef }}</td>
            <td>{{ props.item.seqNo }}</td>
            <td>{{ props.item.attachRefDesc }}</td>
            <td class="text-xs-right">
              <table-action :rowData="props" :review="checkAccess(['claimReview'])" @review="doReview(props.item)" remove @remove="doPromptRemove(props.item)"
                query @query="doQuery(props.item)" />
            </td>
          </template>
        </v-data-table>
      </v-card>
      <div class="pt-2">
        <v-btn color="primary" @click.native="doNew()">
          New Claim Type Attachment
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </div>
      <v-dialog v-model="showClmTypeAttachDialog" width="800px" v-if="checkAccess(['claimReview'])" persistent>
        <clm-type-attach-dialog :selectedClmTypeAttach="selectedClmTypeAttach" :mode="mode" @close="showClmTypeAttachDialog = false" @fetchData="fetchData"/>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove" title="Claim Type Attachment">
        Are you sure that you want to remove the selected claim type attachment? (<b>{{deleteClmTypeAttach.attachRef}} - {{deleteClmTypeAttach.attachRefDesc}}</b>)
      </confirm>
    </div>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import { appIDDesc } from '@/const/underwriting'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import ClmTypeAttachDialog from './ClmTypeAttachDialog'
export default {
  data() {
    return {
      loading: false,
      search: '',
      headers: [
        { text: 'Module', align: 'left', value: 'appId' },
        { text: 'Claim Type', align: 'left', value: 'clmType' },
        { text: 'Sub Type', align: 'left', value: 'clmSubType' },
        { text: 'Attachment Ref', align: 'left', value: 'attachRef' },
        { text: 'Seq No', align: 'left', value: 'seqNo' },
        { text: 'Attachment Description', align: 'left', value: 'attachRefDesc' },
        TableConst.tableActionHeader
      ],
      selectedClmTypeAttach: {
        appId: '',
        clmType: '',
        clmSubType: '',
        attachRef: '',
        attachRefDesc: '',
        seqNo: '',
        isMand: false,
        noCopies: ''
      },
      deleteClmTypeAttach: {},
      mode: '',
      showClmTypeAttachDialog: false,
      promptRemove: false
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      const apiUrl = this.$store.state.claimParam.menu.getClmTypeAttachs
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.items = data
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Unable to retrieve claim type attachments (Missing API URL)')
      }
      this.loading = false
    },
    doNew() {
      this.selectedClmTypeAttach.appId = ''
      this.selectedClmTypeAttach.clmType = ''
      this.selectedClmTypeAttach.clmSubType = ''
      this.selectedClmTypeAttach.attachRef = ''
      this.selectedClmTypeAttach.attachRefDesc = ''
      this.selectedClmTypeAttach.seqNo = ''
      this.selectedClmTypeAttach.isMand = false
      this.selectedClmTypeAttach.noCopies = ''
      this.mode = 'new'
      this.showClmTypeAttachDialog = true
    },
    doQuery(clmTypeAttach) {
      this.selectedClmTypeAttach.appId = clmTypeAttach.appId
      this.selectedClmTypeAttach.clmType = clmTypeAttach.clmType
      this.selectedClmTypeAttach.clmSubType = clmTypeAttach.clmSubType
      this.selectedClmTypeAttach.attachRef = clmTypeAttach.attachRef
      this.selectedClmTypeAttach.attachRefDesc = clmTypeAttach.attachRefDesc
      this.selectedClmTypeAttach.seqNo = clmTypeAttach.seqNo
      this.selectedClmTypeAttach.isMand = clmTypeAttach.isMand
      this.selectedClmTypeAttach.noCopies = clmTypeAttach.noCopies
      this.mode = 'query'
      this.showClmTypeAttachDialog = true
    },
    doReview(clmTypeAttach) {
      this.selectedClmTypeAttach.appId = clmTypeAttach.appId
      this.selectedClmTypeAttach.clmType = clmTypeAttach.clmType
      this.selectedClmTypeAttach.clmSubType = clmTypeAttach.clmSubType
      this.selectedClmTypeAttach.attachRef = clmTypeAttach.attachRef
      this.selectedClmTypeAttach.attachRefDesc = clmTypeAttach.attachRefDesc
      this.selectedClmTypeAttach.seqNo = clmTypeAttach.seqNo
      this.selectedClmTypeAttach.isMand = clmTypeAttach.isMand
      this.selectedClmTypeAttach.noCopies = clmTypeAttach.noCopies
      this.mode = 'review'
      this.showClmTypeAttachDialog = true
    },
    doPromptRemove(clmType) {
      this.deleteClmTypeAttach = clmType
      this.promptRemove = true
    },
    async doRemove() {
      const apiURI = this.$store.state.claimParam.menu.deleteClmTypeAttach
      if (apiURI) {
        this.loading = true
        const expand = {
          appId: this.deleteClmTypeAttach.appId,
          clmType: this.deleteClmTypeAttach.clmType,
          clmSubType: this.deleteClmTypeAttach.clmSubType,
          attachRef: this.deleteClmTypeAttach.attachRef
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          this.fetchData()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    appDesc(appID) {
      return appIDDesc[appID]
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  components: {
    ClmTypeAttachDialog: ClmTypeAttachDialog
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
